import { apiRequest } from "../api/client";
import { visitorAuthService } from "./visitorAuthService";

export const PENDING_QR_KEY = "mvk_pending_qr";

export function getPendingQr(): string | null {
  try {
    return sessionStorage.getItem(PENDING_QR_KEY);
  } catch {
    return null;
  }
}

export function clearPendingQr() {
  try {
    sessionStorage.removeItem(PENDING_QR_KEY);
  } catch {
    // ignore
  }
}

export async function claimPendingQr(): Promise<{
  eventId: string;
  navigateTo: string;
  opaque: string;
} | null> {
  const code = getPendingQr();
  if (!code || !visitorAuthService.isLoggedIn()) return null;
  try {
    const res = await apiRequest<{
      eventId: string;
      navigateTo: string;
      opaque: string;
    }>("/public/qr/claim", {
      method: "POST",
      body: { code },
      audience: "visitor",
    });
    clearPendingQr();
    return res;
  } catch {
    return null;
  }
}
